import { INELIGIBLE_REASON } from '../const/paymentEnterpriseEligibility';
import { t } from '../strings/i18n';
import { checkIneligibilityForAutopayModifyAndCancel, getAutopayModifyUnenrollIneligibility, getAutopayModifyUnenrollIneligibilityReason } from './autopayHelpers';
import { isAutopayModifyEligible, isAutopayUnenrollEligible } from './parseEligibility';
import { isPayLaterProduct, isPN4, isSecuredInstallmentLoanProduct } from './productTypeHelpers';
const getIneligibilityReasons = (paymentEnterpriseEligibility, productType) => {
    const [isModifyIneligiblePriorToFirstStatement, isUnEnrollIneligibleBeforeFirstStatement] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.statementNotGenerated, productType);
    const [isModifyIneligibleWithin48HourWindow] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.within48HourWindow, productType);
    const [isModifyIneligibleForChannelOrProduct, isUnEnrollIneligibleForChannelOrProduct] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.notEnabledForChannelOrProduct, productType);
    const [isModifyIneligibleForDelinquentAccount, isUnEnrollIneligibleForDelinquentAccount] = checkIneligibilityForAutopayModifyAndCancel(paymentEnterpriseEligibility, INELIGIBLE_REASON.notEligibleDueToDelinquency, productType);
    return {
        isModifyIneligiblePriorToFirstStatement,
        isUnEnrollIneligibleBeforeFirstStatement,
        isModifyIneligibleWithin48HourWindow,
        isModifyIneligibleForChannelOrProduct,
        isUnEnrollIneligibleForChannelOrProduct,
        isModifyIneligibleForDelinquentAccount,
        isUnEnrollIneligibleForDelinquentAccount
    };
};
// eslint-disable-next-line max-lines-per-function
export const getManageAutopayMessage = ({ paymentEnterpriseEligibility, nextDueDate, helpNumber, productType }) => {
    const isAutopayUnEnrollEligible = isAutopayUnenrollEligible(productType, paymentEnterpriseEligibility);
    const isAutopayModifyIneligible = !isAutopayModifyEligible(paymentEnterpriseEligibility);
    /**
     * Restricting the logic to Pay Later Products
     * because other products does not have the AUTOPAY_UNENROLL support yet
     */
    const displayUnEnrollIneligibilityMessage = isPayLaterProduct(productType) &&
        !isAutopayUnEnrollEligible &&
        !isAutopayModifyIneligible;
    // Checking the InEneligibility reason 👇
    const { isModifyIneligiblePriorToFirstStatement, isUnEnrollIneligibleBeforeFirstStatement, isModifyIneligibleWithin48HourWindow, isModifyIneligibleForChannelOrProduct, isUnEnrollIneligibleForChannelOrProduct, isModifyIneligibleForDelinquentAccount, isUnEnrollIneligibleForDelinquentAccount } = getIneligibilityReasons(paymentEnterpriseEligibility, productType);
    const isModifyUnEnrollIneligiblePriorToFirstStatement = getAutopayModifyUnenrollIneligibilityReason(productType, isModifyIneligiblePriorToFirstStatement, isUnEnrollIneligibleBeforeFirstStatement);
    const isModifyUnEnrollIneligibleForChannelOrProduct = getAutopayModifyUnenrollIneligibilityReason(productType, isModifyIneligibleForChannelOrProduct, isUnEnrollIneligibleForChannelOrProduct);
    const isModifyUnEnrollIneligibleForDelinquentAccount = getAutopayModifyUnenrollIneligibilityReason(productType, isModifyIneligibleForDelinquentAccount, isUnEnrollIneligibleForDelinquentAccount);
    const isAutopayModifyAndUnenrollIneligible = getAutopayModifyUnenrollIneligibility(productType, isAutopayModifyIneligible, isAutopayUnEnrollEligible);
    if (isAutopayModifyAndUnenrollIneligible) {
        const isPN4Product = isPN4(productType);
        const isSI = isSecuredInstallmentLoanProduct(productType);
        if (isSI && isModifyUnEnrollIneligiblePriorToFirstStatement) {
            return t('autopayCollapseBanner.autopaySIEditPriorFirstStatement', {
                helpNumber
            });
        }
        if (isModifyUnEnrollIneligiblePriorToFirstStatement ||
            (isPN4Product && isModifyIneligiblePriorToFirstStatement)) {
            return t('autopayCollapseBanner.autopayEditPriorFirstStatement');
        }
        if (isModifyUnEnrollIneligibleForChannelOrProduct ||
            (isSI && isModifyUnEnrollIneligibleForDelinquentAccount) ||
            (isPN4Product && isModifyIneligibleForChannelOrProduct)) {
            return t('autopayCollapseBanner.autopayEditNotEnabledForChannelOrProduct', {
                helpNumber
            });
        }
        return t('autopayCollapseBanner.autopayModifyInEligibleUnhandledReason');
    }
    if (isModifyIneligibleWithin48HourWindow) {
        return t('autopayCollapseBanner.modifyNotEligibleWithin48HourWindow');
    }
    if (displayUnEnrollIneligibilityMessage) {
        return t('autopayCollapseBanner.autopayUnEnrollIneligibilityMessage');
    }
    if (!nextDueDate) {
        return t('autopay.noNextDueDate');
    }
    return null;
};
